import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _clothes, _clothes2, _rocker, _rocker2, _clothes3, _clothes4, _clothes5, _clothes6, _clothes7, _clothes8, _clothes9, _clothes10, _clothes11, _clothes12;

export var rockingChair = _defineProperty({
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "8e16adac-4453-1e35-de76-5ad93bc0bf2f",
  "ProductId": "628500",
  "ProductName": "Rutledge Weather-Resistant Rocking Chair",
  "DisplayName": "Rutledge Weather-Resistant Rocking Chair",
  "Description": "This weather-resistant Rutledge Rocking Chair is crafted from 100% solid acacia wood and protected by a weatherproof finish. Each chair features lathe-turned front posts and elegant rounded arms. Perfect for any porch, deck, or patio!",
  "CurrencySymbol": "USD",
  "ListPrice": 139.99,
  "AdjustedPrice": 139.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "Images": [{
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-0.jpg",
    "DisplaySequence": 5,
    "ImageName": "628503-0.jpg",
    "AltText": "Elm",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }, {
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-1.jpg",
    "DisplaySequence": 6,
    "ImageName": "628503-1.jpg",
    "AltText": "Elm",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }, {
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-2.jpg",
    "DisplaySequence": 7,
    "ImageName": "628503-2.jpg",
    "AltText": "Elm",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }],
  "Variants": [{
    "ProductVariantId": "628503",
    "CurrencySymbol": "USD",
    "ListPrice": 139.99,
    "AdjustedPrice": 139.99,
    "VariantProperties": {
      "Color": "Elm",
      "Size": ""
    },
    "Images": [{
      "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-0.jpg",
      "DisplaySequence": 5,
      "ImageName": "628503-0.jpg",
      "AltText": "Elm",
      "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
      "ParentSKU": 0,
      "SKU": 0,
      "CategoryId": 0
    }, {
      "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-1.jpg",
      "DisplaySequence": 6,
      "ImageName": "628503-1.jpg",
      "AltText": "Elm",
      "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
      "ParentSKU": 0,
      "SKU": 0,
      "CategoryId": 0
    }, {
      "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-2.jpg",
      "DisplaySequence": 7,
      "ImageName": "628503-2.jpg",
      "AltText": "Elm",
      "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/Swatches/CCT-Elm-Swatch.jpg",
      "ParentSKU": 0,
      "SKU": 0,
      "CategoryId": 0
    }]
  }],
  "Attributes": {
    "Brand": "Carolina Chair & Table Company",
    "Gift_Wrap_Choice": false,
    "Dimensions": "<ul><li>45\" H x 36\" L x 23.5\" W</li><li>Seat measures 17.5\" H x 19.365\" W x 19.5\" D</li></ul>",
    "Collection": "",
    "Care_And_Maintenance": "",
    "Features": "<ul><li>Side table sold separately</li><li>100% solid acacia wood with weatherproof finish</li></ul>",
    "Materials": "",
    "Origin": "Imported",
    "Video": "",
    "Shipping_Information": "",
    "Details": "Click <a href=\"/cms/files/b38fcdd5-3120-40bd-ac9a-a136e8fd0b33\" target=\"_blank\">here</a> for warranty information.",
    "Assembly_Information": null,
    "Cb_Exclusive_Product": false,
    "Bulk_Quantity": "",
    "California_Residents": "",
    "Age_Range": "",
    "Track_Listing": "",
    "Handling_Fee": "",
    "Military_Branch": "",
    "Indoor_Outdoor": "",
    "Vendor": "Carolina Chair",
    "Choose_Your_School": "",
    "College": "",
    "Conference": "",
    "Promotion_Info": "",
    "Dropship": "TRUE",
    "Nfl": "",
    "State": "",
    "Size_Chart": ""
  },
  "ImageUrls": ["https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Carolina-Chair/628503-0.jpg"]
}, "DetailLink", "/shop/clothing/shirts/top/628500");
export var clothes1 = (_clothes = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "e82d4cf5-b9c1-3a7d-80dc-2de8943d44a1",
  "ProductId": "722506",
  "ProductName": "Ivory Crochet Duster",
  "DisplayName": "Ivory Crochet Duster",
  "Description": "Lightweight and easy, this top is anything but simple with beautifully embroidered sleeves and a pop of lace in the back bringing style to a staple. Model is 5'8\" and wearing a size small.",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg"]
}, _defineProperty(_clothes, "DetailLink", "/shop/clothing/shirts/top/722506"), _defineProperty(_clothes, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "722506-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "722506-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg",
  "DisplaySequence": 3,
  "ImageName": "722506-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-1.jpg",
  "DisplaySequence": 4,
  "ImageName": "722506-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "722506-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "722506-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "722506-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "722506-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "722506-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/722506-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "722506-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes, "Variants", [{
  "ProductVariantId": "722507",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "722508",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "722509",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "722510",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "722511",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes);
export var clothes2 = (_clothes2 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "bd33eecd-899b-0134-0c14-d00b0619f678",
  "ProductId": "708928",
  "ProductName": "Crochet Mixed Media Dress",
  "DisplayName": "Crochet Mixed Media Dress",
  "Description": "Get ready to turn some heads! This stunning Crochet Mixed Media Dress is as eye-catching as they come! With a beautiful cut and gorgeous crochet detail, this dress is a real show-stopper!",
  "CurrencySymbol": "USD",
  "ListPrice": 44.99,
  "AdjustedPrice": 44.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-0.jpg"]
}, _defineProperty(_clothes2, "DetailLink", "/shop/clothing/shirts/top/708928"), _defineProperty(_clothes2, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "708928-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "708928-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-0.jpg",
  "DisplaySequence": 3,
  "ImageName": "708928-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-1.jpg",
  "DisplaySequence": 4,
  "ImageName": "708928-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "708928-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY20/FY-20-Blush-Vintage/708928-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "708928-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes2, "Variants", [{
  "ProductVariantId": "708931",
  "CurrencySymbol": "USD",
  "ListPrice": 44.99,
  "AdjustedPrice": 44.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "708932",
  "CurrencySymbol": "USD",
  "ListPrice": 44.99,
  "AdjustedPrice": 44.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "708933",
  "CurrencySymbol": "USD",
  "ListPrice": 44.99,
  "AdjustedPrice": 44.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}]), _defineProperty(_clothes2, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Vintage Ivory",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes2);
export var rocker = (_rocker = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "09297caf-df60-2ee6-57e7-aeb4d6248a23",
  "ProductId": "659591",
  "ProductName": "Farmhouse Rocker",
  "DisplayName": "Farmhouse Rocker",
  "Description": "This updated version of an old style farmhouse rocking chair would make great addition to a front porch or living area.  The ladderback style and slat seat offer comfort as well as a fresh look.  The Farm House Collection is offered in 6 colors:  Antique Gray, Antique Stone, Maple, Black, White or Chestnut.",
  "CurrencySymbol": "USD",
  "ListPrice": 219.99,
  "AdjustedPrice": 219.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659603-0.jpg"]
}, _defineProperty(_rocker, "DetailLink", "/shop/clothing/shirts/top/659591"), _defineProperty(_rocker, "Images", [{
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659603-0.jpg",
  "DisplaySequence": 3,
  "ImageName": "659603-0.jpg",
  "AltText": "Chestnut",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/chestnut-swatch.jpg",
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0
}, {
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659604-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "659604-0.jpg",
  "AltText": "Maple",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/maple-swatch.jpg",
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0
}, {
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659605-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "659605-0.jpg",
  "AltText": "Antique Stone",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/antique-stone-swatch.jpg",
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0
}, {
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659606-0.jpg",
  "DisplaySequence": 6,
  "ImageName": "659606-0.jpg",
  "AltText": "Antique Gray",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/antique-gray-swatch.jpg",
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0
}]), _defineProperty(_rocker, "Variants", [{
  "ProductVariantId": "659603",
  "CurrencySymbol": "USD",
  "ListPrice": 199.99,
  "AdjustedPrice": 199.99,
  "VariantProperties": {
    "Color": "Chestnut",
    "Size": ""
  },
  "Images": [{
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659603-0.jpg",
    "DisplaySequence": 3,
    "ImageName": "659603-0.jpg",
    "AltText": "Chestnut",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/chestnut-swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }]
}, {
  "ProductVariantId": "659604",
  "CurrencySymbol": "USD",
  "ListPrice": 199.99,
  "AdjustedPrice": 199.99,
  "VariantProperties": {
    "Color": "Maple",
    "Size": ""
  },
  "Images": [{
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659604-0.jpg",
    "DisplaySequence": 4,
    "ImageName": "659604-0.jpg",
    "AltText": "Maple",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/maple-swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }]
}, {
  "ProductVariantId": "659605",
  "CurrencySymbol": "USD",
  "ListPrice": 239.99,
  "AdjustedPrice": 239.99,
  "VariantProperties": {
    "Color": "Antique Stone",
    "Size": ""
  },
  "Images": [{
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659605-0.jpg",
    "DisplaySequence": 5,
    "ImageName": "659605-0.jpg",
    "AltText": "Antique Stone",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/antique-stone-swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }]
}, {
  "ProductVariantId": "659606",
  "CurrencySymbol": "USD",
  "ListPrice": 239.99,
  "AdjustedPrice": 239.99,
  "VariantProperties": {
    "Color": "Antique Gray",
    "Size": ""
  },
  "Images": [{
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/659606-0.jpg",
    "DisplaySequence": 6,
    "ImageName": "659606-0.jpg",
    "AltText": "Antique Gray",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/antique-gray-swatch.jpg",
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0
  }]
}]), _defineProperty(_rocker, "Attributes", {
  "Brand": "Hinkle Chair Company",
  "Gift_Wrap_Choice": false,
  "Dimensions": "<ul><li>Chair dimensions - 48\" H x 34\" D</li><li>Seat dimensions - 22\" W x 21\" D</li></ul>",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "<ul><li>RTA (Ready to Assemble)</li><li>Ladderback Style</li><li>Contoured Seat and Back</li><li>Solid Hardwood Construction</li></ul>",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "TRUE",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _rocker);
export var rocker2 = (_rocker2 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "8e1109b0-59b9-ca2d-4b73-31ca4dc66b4e",
  "ProductId": "662457",
  "ProductName": "Bent Wood Style Rocker",
  "DisplayName": "Bent Wood Style Rocker",
  "Description": "This classic rocker is designed with a distinctive contoured seat and back that adds beauty and comfort. It is available in beech wood that can be stained with maple or chestnut color or painted in black or white.",
  "CurrencySymbol": "USD",
  "ListPrice": 329.99,
  "AdjustedPrice": 329.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662458-0.JPG"]
}, _defineProperty(_rocker2, "DetailLink", "/shop/clothing/shirts/top/662457"), _defineProperty(_rocker2, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662458-0.JPG",
  "DisplaySequence": 1,
  "ImageName": "662458-0.JPG",
  "AltText": "Black",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/black-swatch.jpg"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662459-0.JPG",
  "DisplaySequence": 2,
  "ImageName": "662459-0.JPG",
  "AltText": "White",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/white-swatch.jpg"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662460-0.jpg",
  "DisplaySequence": 3,
  "ImageName": "662460-0.jpg",
  "AltText": "Maple",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/maple-swatch.jpg"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662461-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "662461-0.jpg",
  "AltText": "Walnut",
  "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/walnut-swatch.jpg"
}]), _defineProperty(_rocker2, "Variants", [{
  "ProductVariantId": "662458",
  "CurrencySymbol": "USD",
  "ListPrice": 329.99,
  "AdjustedPrice": 329.99,
  "VariantProperties": {
    "Color": "Black",
    "Size": ""
  },
  "Images": [{
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0,
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662458-0.JPG",
    "DisplaySequence": 1,
    "ImageName": "662458-0.JPG",
    "AltText": "Black",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/black-swatch.jpg"
  }]
}, {
  "ProductVariantId": "662459",
  "CurrencySymbol": "USD",
  "ListPrice": 329.99,
  "AdjustedPrice": 329.99,
  "VariantProperties": {
    "Color": "White",
    "Size": ""
  },
  "Images": [{
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0,
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662459-0.JPG",
    "DisplaySequence": 2,
    "ImageName": "662459-0.JPG",
    "AltText": "White",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/white-swatch.jpg"
  }]
}, {
  "ProductVariantId": "662460",
  "CurrencySymbol": "USD",
  "ListPrice": 329.99,
  "AdjustedPrice": 329.99,
  "VariantProperties": {
    "Color": "Maple",
    "Size": ""
  },
  "Images": [{
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0,
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662460-0.jpg",
    "DisplaySequence": 3,
    "ImageName": "662460-0.jpg",
    "AltText": "Maple",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/maple-swatch.jpg"
  }]
}, {
  "ProductVariantId": "662461",
  "CurrencySymbol": "USD",
  "ListPrice": 329.99,
  "AdjustedPrice": 329.99,
  "VariantProperties": {
    "Color": "Walnut",
    "Size": ""
  },
  "Images": [{
    "ParentSKU": 0,
    "SKU": 0,
    "CategoryId": 0,
    "ImageUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/662461-0.jpg",
    "DisplaySequence": 4,
    "ImageName": "662461-0.jpg",
    "AltText": "Walnut",
    "SwatchUrl": "https://s3.amazonaws.com/cbrl-ecom-images/VendorNet/Hinkle/Farmhouse/walnut-swatch.jpg"
  }]
}]), _defineProperty(_rocker2, "Attributes", {
  "Brand": "Hinkle Chair Company",
  "Gift_Wrap_Choice": false,
  "Dimensions": "<ul><li>Overall Size: 25.5&rdquo; W x 34&rdquo; D x 46&rdquo; H</li><li>Seat Size: 20&rdquo; W x 20&rdquo; D</li></ul>",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "<ul><li>RTA (Ready to Assemble)</li><li>Distinctive Design</li><li>Contoured Seat and Back</li><li>Solid Hardwood Construction</li></ul>",
  "Materials": "",
  "Origin": "USA",
  "Video": "",
  "Shipping_Information": "",
  "Details": "",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "TRUE",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _rocker2);
export var clothes3 = (_clothes3 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "46c2c450-77eb-18d2-0a85-7bcc2bf67675",
  "ProductId": "729764",
  "ProductName": "Grey Bling Wreath Sweater",
  "DisplayName": "Grey Bling Wreath Sweater",
  "Description": "Our wreath bling sweater has an ease to it with the fit and comfort you love. The updated puffed sleeves gives the shoulder an extra feminine touch. Model is 5'8\" and wearing a size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg"]
}, _defineProperty(_clothes3, "DetailLink", "/shop/clothing/shirts/top/729764"), _defineProperty(_clothes3, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729764-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729764-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729764-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "729764-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-1.jpg",
  "DisplaySequence": 5,
  "ImageName": "729764-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-2.jpg",
  "DisplaySequence": 6,
  "ImageName": "729764-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "729764-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "729764-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-2.jpg",
  "DisplaySequence": 9,
  "ImageName": "729764-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg",
  "DisplaySequence": 10,
  "ImageName": "729764-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-1.jpg",
  "DisplaySequence": 11,
  "ImageName": "729764-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-2.jpg",
  "DisplaySequence": 12,
  "ImageName": "729764-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "729764-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "729764-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729764-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "729764-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes3, "Variants", [{
  "ProductVariantId": "729765",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729766",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729767",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "729768",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "729769",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes3, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes3);
export var clothes4 = (_clothes4 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "875b1997-0dac-f61d-1859-9c90119c4f63",
  "ProductId": "729788",
  "ProductName": "Black Stacked Cardinals Fleece",
  "DisplayName": "Black Stacked Cardinals Fleece",
  "Description": "A tree of stacked embroidered cardinals add an update to a Cracker Barrel Favorite! The pop of red on the neckline and bling add interest to this cozy and warm sweatshirt! Model is 5'8\" and wearing size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-0.jpg"]
}, _defineProperty(_clothes4, "DetailLink", "/shop/clothing/shirts/top/729788"), _defineProperty(_clothes4, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729788-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729788-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729788-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-3.jpg",
  "DisplaySequence": 4,
  "ImageName": "729788-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "729788-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "729788-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-2.jpg",
  "DisplaySequence": 7,
  "ImageName": "729788-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-3.jpg",
  "DisplaySequence": 8,
  "ImageName": "729788-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "729788-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "729788-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-2.jpg",
  "DisplaySequence": 11,
  "ImageName": "729788-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729788-3.jpg",
  "DisplaySequence": 12,
  "ImageName": "729788-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes4, "Variants", [{
  "ProductVariantId": "729789",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729790",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729791",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}]), _defineProperty(_clothes4, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes4);
export var clothes5 = (_clothes5 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "6d0664fa-0d48-e506-57a3-8edb85354bfc",
  "ProductId": "733811",
  "ProductName": "Black Cardigan with Eyelash Trim Collar",
  "DisplayName": "Black Cardigan with Eyelash Trim Collar",
  "Description": "Our black cardigan has universal appeal! It goes with everything, it's cozy, and it's eyelash trim gives this piece texture and movement! Model is 5'8\" and wearing a size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg"]
}, _defineProperty(_clothes5, "DetailLink", "/shop/clothing/shirts/top/733811"), _defineProperty(_clothes5, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "733811-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "733811-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "733811-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-3.jpg",
  "DisplaySequence": 4,
  "ImageName": "733811-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "733811-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "733811-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-2.jpg",
  "DisplaySequence": 7,
  "ImageName": "733811-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-3.jpg",
  "DisplaySequence": 8,
  "ImageName": "733811-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "733811-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "733811-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-2.jpg",
  "DisplaySequence": 11,
  "ImageName": "733811-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-3.jpg",
  "DisplaySequence": 12,
  "ImageName": "733811-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "733811-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "733811-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "733811-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-3.jpg",
  "DisplaySequence": 16,
  "ImageName": "733811-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-0.jpg",
  "DisplaySequence": 17,
  "ImageName": "733811-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-1.jpg",
  "DisplaySequence": 18,
  "ImageName": "733811-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-2.jpg",
  "DisplaySequence": 19,
  "ImageName": "733811-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/733811-3.jpg",
  "DisplaySequence": 20,
  "ImageName": "733811-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes5, "Variants", [{
  "ProductVariantId": "733812",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "733813",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "733814",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "733815",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "733816",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes5, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes5);
export var clothes6 = (_clothes6 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "f88f7105-3ac3-cc37-6ee2-bd69d5038482",
  "ProductId": "729732",
  "ProductName": "Ivory Bow and Snowflake Neckline Top",
  "DisplayName": "Ivory Bow and Snowflake Neckline Top",
  "Description": "This soft and cozy top is anything but basic! The neckline is accented by bows, snowflakes, bling, and grommets white the cut of the top gives extra coverage on the back in a flattering way! Model is 5'8\" and wearing a size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg"]
}, _defineProperty(_clothes6, "DetailLink", "/shop/clothing/shirts/top/729732"), _defineProperty(_clothes6, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729732-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729732-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729732-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-3.jpg",
  "DisplaySequence": 4,
  "ImageName": "729732-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "729732-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "729732-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-2.jpg",
  "DisplaySequence": 7,
  "ImageName": "729732-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-3.jpg",
  "DisplaySequence": 8,
  "ImageName": "729732-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "729732-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "729732-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-2.jpg",
  "DisplaySequence": 11,
  "ImageName": "729732-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-3.jpg",
  "DisplaySequence": 12,
  "ImageName": "729732-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "729732-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "729732-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "729732-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-3.jpg",
  "DisplaySequence": 16,
  "ImageName": "729732-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-0.jpg",
  "DisplaySequence": 17,
  "ImageName": "729732-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-1.jpg",
  "DisplaySequence": 18,
  "ImageName": "729732-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-2.jpg",
  "DisplaySequence": 19,
  "ImageName": "729732-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729732-3.jpg",
  "DisplaySequence": 20,
  "ImageName": "729732-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes6, "Variants", [{
  "ProductVariantId": "729733",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729734",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729735",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "729736",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "729737",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes6, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes6);
export var clothes7 = (_clothes7 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "bba9c6f4-101e-0c28-7f8d-aa067fb927e9",
  "ProductId": "729708",
  "ProductName": "Cranberry Crinkle Embroidered Neck Dress",
  "DisplayName": "Cranberry Crinkle Embroidered Neck Dress",
  "Description": "The crinkle fabrication of this dress gives it a lightweight ease, detailed embroidery around the neckline with a drawstring to cinch in the waist makes this dress easy and flattering. Model is 5'8\" wearing a size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg"]
}, _defineProperty(_clothes7, "DetailLink", "/shop/clothing/shirts/top/729708"), _defineProperty(_clothes7, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729708-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729708-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729708-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-3.jpg",
  "DisplaySequence": 4,
  "ImageName": "729708-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "729708-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "729708-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-2.jpg",
  "DisplaySequence": 7,
  "ImageName": "729708-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-3.jpg",
  "DisplaySequence": 8,
  "ImageName": "729708-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "729708-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "729708-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-2.jpg",
  "DisplaySequence": 11,
  "ImageName": "729708-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-3.jpg",
  "DisplaySequence": 12,
  "ImageName": "729708-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "729708-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "729708-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "729708-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-3.jpg",
  "DisplaySequence": 16,
  "ImageName": "729708-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-0.jpg",
  "DisplaySequence": 17,
  "ImageName": "729708-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-1.jpg",
  "DisplaySequence": 18,
  "ImageName": "729708-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-2.jpg",
  "DisplaySequence": 19,
  "ImageName": "729708-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729708-3.jpg",
  "DisplaySequence": 20,
  "ImageName": "729708-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes7, "Variants", [{
  "ProductVariantId": "729709",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729710",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729711",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "729712",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "729713",
  "CurrencySymbol": "USD",
  "ListPrice": 39.99,
  "AdjustedPrice": 39.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes7, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes7);
export var clothes8 = (_clothes8 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "b7209f6f-899f-8b46-9747-6134967ebd48",
  "ProductId": "729724",
  "ProductName": "Red Scotty Dog Snow Fleece",
  "DisplayName": "Red Scotty Dog Snow Fleece",
  "Description": "Don't worry he won't bite! This sweet embroidered Scotty Dog sits a wintery scene giving this fleece textural variations that add interest to a cozy and warm sweatshirt with an added layer on the neckline!",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-0.jpg"]
}, _defineProperty(_clothes8, "DetailLink", "/shop/clothing/shirts/top/729724"), _defineProperty(_clothes8, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729724-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729724-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729724-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-3.jpg",
  "DisplaySequence": 4,
  "ImageName": "729724-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-0.jpg",
  "DisplaySequence": 5,
  "ImageName": "729724-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-1.jpg",
  "DisplaySequence": 6,
  "ImageName": "729724-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-2.jpg",
  "DisplaySequence": 7,
  "ImageName": "729724-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-3.jpg",
  "DisplaySequence": 8,
  "ImageName": "729724-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-0.jpg",
  "DisplaySequence": 9,
  "ImageName": "729724-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-1.jpg",
  "DisplaySequence": 10,
  "ImageName": "729724-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-2.jpg",
  "DisplaySequence": 11,
  "ImageName": "729724-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-3.jpg",
  "DisplaySequence": 12,
  "ImageName": "729724-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-0.jpg",
  "DisplaySequence": 17,
  "ImageName": "729724-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-1.jpg",
  "DisplaySequence": 18,
  "ImageName": "729724-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-2.jpg",
  "DisplaySequence": 19,
  "ImageName": "729724-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729724-3.jpg",
  "DisplaySequence": 20,
  "ImageName": "729724-3.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes8, "Variants", [{
  "ProductVariantId": "729725",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729726",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729727",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "729729",
  "CurrencySymbol": "USD",
  "ListPrice": 19.99,
  "AdjustedPrice": 19.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes8, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes8);
export var clothes9 = (_clothes9 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "e1b0812c-39fd-b553-3853-24fd1bbf4705",
  "ProductId": "729780",
  "ProductName": "White Reindeer and Bling V-Neck Top",
  "DisplayName": "White Reindeer and Bling V-Neck Top",
  "Description": "This cozy top has fit that works for every figure with the side split seams and slightly elongated sides. The reindeer pops in plaid and is outlined with a little bling, perfect for this holiday season! Model is 5'8\" and wearing a size medium.",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg"]
}, _defineProperty(_clothes9, "DetailLink", "/shop/clothing/shirts/top/729780"), _defineProperty(_clothes9, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "729780-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "729780-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "729780-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "729780-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-1.jpg",
  "DisplaySequence": 5,
  "ImageName": "729780-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-2.jpg",
  "DisplaySequence": 6,
  "ImageName": "729780-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "729780-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "729780-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-2.jpg",
  "DisplaySequence": 9,
  "ImageName": "729780-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg",
  "DisplaySequence": 10,
  "ImageName": "729780-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-1.jpg",
  "DisplaySequence": 11,
  "ImageName": "729780-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-2.jpg",
  "DisplaySequence": 12,
  "ImageName": "729780-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "729780-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "729780-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/Traditional/729780-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "729780-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes9, "Variants", [{
  "ProductVariantId": "729781",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "S"
  },
  "Images": []
}, {
  "ProductVariantId": "729782",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "M"
  },
  "Images": []
}, {
  "ProductVariantId": "729783",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "L"
  },
  "Images": []
}, {
  "ProductVariantId": "729784",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XL"
  },
  "Images": []
}, {
  "ProductVariantId": "729785",
  "CurrencySymbol": "USD",
  "ListPrice": 29.99,
  "AdjustedPrice": 29.99,
  "VariantProperties": {
    "Color": "",
    "Size": "XXL"
  },
  "Images": []
}]), _defineProperty(_clothes9, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "Traditional",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "<a href=\"https://cbrl-ecom-images.s3.amazonaws.com/Apparel/Womens_size_chart_final.pdf\" target=\"_self\">Click Here for Size Chart</a>",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes9);
export var clothes10 = (_clothes10 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "0141ab4f-c630-4449-a080-bd395b61e875",
  "ProductId": "723322",
  "ProductName": "Toddler Embroidered Bow Back Dress",
  "DisplayName": "Toddler Embroidered Bow Back Dress",
  "Description": "This little peasant dress is picture perfect for a celebration! Little vibrant embroidered flowers pop on the bib, neckline and sleeves of the dress. Don't forget to twirl around to see the sweet bow detailing on the back!",
  "CurrencySymbol": "USD",
  "ListPrice": 21.99,
  "AdjustedPrice": 21.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-0.jpg"]
}, _defineProperty(_clothes10, "DetailLink", "/shop/clothing/shirts/top/723322"), _defineProperty(_clothes10, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "723322-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "723322-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "723322-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "723322-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-1.jpg",
  "DisplaySequence": 5,
  "ImageName": "723322-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-2.jpg",
  "DisplaySequence": 6,
  "ImageName": "723322-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "723322-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "723322-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-2.jpg",
  "DisplaySequence": 9,
  "ImageName": "723322-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-0.jpg",
  "DisplaySequence": 10,
  "ImageName": "723322-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-1.jpg",
  "DisplaySequence": 11,
  "ImageName": "723322-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723322-2.jpg",
  "DisplaySequence": 12,
  "ImageName": "723322-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes10, "Variants", [{
  "ProductVariantId": "723323",
  "CurrencySymbol": "USD",
  "ListPrice": 21.99,
  "AdjustedPrice": 21.99,
  "VariantProperties": {
    "Color": "",
    "Size": "2T"
  },
  "Images": []
}, {
  "ProductVariantId": "723324",
  "CurrencySymbol": "USD",
  "ListPrice": 21.99,
  "AdjustedPrice": 21.99,
  "VariantProperties": {
    "Color": "",
    "Size": "3T"
  },
  "Images": []
}, {
  "ProductVariantId": "723325",
  "CurrencySymbol": "USD",
  "ListPrice": 21.99,
  "AdjustedPrice": 21.99,
  "VariantProperties": {
    "Color": "",
    "Size": "4T"
  },
  "Images": []
}, {
  "ProductVariantId": "723326",
  "CurrencySymbol": "USD",
  "ListPrice": 21.99,
  "AdjustedPrice": 21.99,
  "VariantProperties": {
    "Color": "",
    "Size": "5Y"
  },
  "Images": []
}]), _defineProperty(_clothes10, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes10);
export var clothes11 = (_clothes11 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "8333d946-5a50-021c-8c9d-246825e69dba",
  "ProductId": "723518",
  "ProductName": "Infant Horse Trio Bloomer Set",
  "DisplayName": "Infant Horse Trio Bloomer Set",
  "Description": "Little horses gallop around the hem giving this little top lots of movement! Flower Bloomers and headband bring the detail of the embroidery out, rounding out this sweet set.",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg"]
}, _defineProperty(_clothes11, "DetailLink", "/shop/clothing/shirts/top/723518"), _defineProperty(_clothes11, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "723518-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "723518-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "723518-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "723518-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-1.jpg",
  "DisplaySequence": 5,
  "ImageName": "723518-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-2.jpg",
  "DisplaySequence": 6,
  "ImageName": "723518-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "723518-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "723518-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-2.jpg",
  "DisplaySequence": 9,
  "ImageName": "723518-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg",
  "DisplaySequence": 10,
  "ImageName": "723518-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-1.jpg",
  "DisplaySequence": 11,
  "ImageName": "723518-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-2.jpg",
  "DisplaySequence": 12,
  "ImageName": "723518-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-0.jpg",
  "DisplaySequence": 13,
  "ImageName": "723518-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-1.jpg",
  "DisplaySequence": 14,
  "ImageName": "723518-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/723518-2.jpg",
  "DisplaySequence": 15,
  "ImageName": "723518-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes11, "Variants", [{
  "ProductVariantId": "723519",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "VariantProperties": {
    "Color": "",
    "Size": "3 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "723520",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "VariantProperties": {
    "Color": "",
    "Size": "6 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "723521",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "VariantProperties": {
    "Color": "",
    "Size": "9 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "723522",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "VariantProperties": {
    "Color": "",
    "Size": "12 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "723523",
  "CurrencySymbol": "USD",
  "ListPrice": 24.99,
  "AdjustedPrice": 24.99,
  "VariantProperties": {
    "Color": "",
    "Size": "18 Mo."
  },
  "Images": []
}]), _defineProperty(_clothes11, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes11);
export var clothes12 = (_clothes12 = {
  "CatalogName": "CB_Retail_Store",
  "SitecoreId": "e290a3e9-35dc-a233-e293-02e8b4823da9",
  "ProductId": "725162",
  "ProductName": "Infant Navy Sparkle Boot",
  "DisplayName": "Infant Navy Sparkle Boot",
  "Description": "Soft navy faux suede infant boots are accented with a sparkle heel and sassy tassel for your little! Velcro closures make for easy on and off with this little boot!",
  "CurrencySymbol": "USD",
  "ListPrice": 14.99,
  "AdjustedPrice": 14.99,
  "TaxCode": null,
  "ProductWeight": "1",
  "ProductLength": "1",
  "ProductWidth": "1",
  "ProductHeight": "1",
  "AvailableInventory": 0,
  "DetailLink": null,
  "IsFavourite": false,
  "IsActive": true,
  "Slug": null,
  "IsExclusive": false,
  "StockStatusName": "",
  "ShippingInformation": null,
  "SizeChartInformation": null,
  "ImageUrls": ["https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-0.jpg"]
}, _defineProperty(_clothes12, "DetailLink", "/shop/clothing/shirts/top/725162"), _defineProperty(_clothes12, "Images", [{
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-0.jpg",
  "DisplaySequence": 1,
  "ImageName": "725162-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-1.jpg",
  "DisplaySequence": 2,
  "ImageName": "725162-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-2.jpg",
  "DisplaySequence": 3,
  "ImageName": "725162-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-0.jpg",
  "DisplaySequence": 4,
  "ImageName": "725162-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-1.jpg",
  "DisplaySequence": 5,
  "ImageName": "725162-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-2.jpg",
  "DisplaySequence": 6,
  "ImageName": "725162-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-0.jpg",
  "DisplaySequence": 7,
  "ImageName": "725162-0.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-1.jpg",
  "DisplaySequence": 8,
  "ImageName": "725162-1.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}, {
  "ParentSKU": 0,
  "SKU": 0,
  "CategoryId": 0,
  "ImageUrl": "https://cbrl-ecom-images.s3.amazonaws.com/FY21/AIS/725162-2.jpg",
  "DisplaySequence": 9,
  "ImageName": "725162-2.jpg",
  "AltText": "0",
  "SwatchUrl": "0"
}]), _defineProperty(_clothes12, "Variants", [{
  "ProductVariantId": "725163",
  "CurrencySymbol": "USD",
  "ListPrice": 14.99,
  "AdjustedPrice": 14.99,
  "VariantProperties": {
    "Color": "",
    "Size": "3-6 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "725164",
  "CurrencySymbol": "USD",
  "ListPrice": 14.99,
  "AdjustedPrice": 14.99,
  "VariantProperties": {
    "Color": "",
    "Size": "9-12 Mo."
  },
  "Images": []
}, {
  "ProductVariantId": "725165",
  "CurrencySymbol": "USD",
  "ListPrice": 14.99,
  "AdjustedPrice": 14.99,
  "VariantProperties": {
    "Color": "",
    "Size": "6-9 Mo."
  },
  "Images": []
}]), _defineProperty(_clothes12, "Attributes", {
  "Brand": "",
  "Gift_Wrap_Choice": false,
  "Dimensions": "",
  "Collection": "",
  "Care_And_Maintenance": "",
  "Features": "",
  "Materials": "",
  "Origin": "Imported",
  "Video": "",
  "Shipping_Information": "",
  "Details": "",
  "Assembly_Information": null,
  "Cb_Exclusive_Product": false,
  "Bulk_Quantity": "",
  "California_Residents": "",
  "Age_Range": "",
  "Track_Listing": "",
  "Handling_Fee": "",
  "Military_Branch": "",
  "Indoor_Outdoor": "",
  "Vendor": "",
  "Choose_Your_School": "",
  "College": "",
  "Conference": "",
  "Promotion_Info": "",
  "Dropship": "",
  "Nfl": "",
  "State": "",
  "Size_Chart": ""
}), _clothes12);